import React from 'react';
import styles from './AppointmentDetails.module.css';
import iconBack from '../../../images/icon-chevron-left.svg';
import dummyAvatar from '../../../images/chat-user-1.svg';
import iconPagination from '../../../images/icon-chevron-left.svg';

const AppointmentDetails = () => {
    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h2 className={styles.title}>
                    <span className={styles.backWrapper}>
                        <img src={iconBack} alt="Back" />
                    </span>
                    Appointment Details
                </h2>
                <span className={`${styles.keyStatus} ${styles.pending} ${styles.received}`}>Key Pending</span>
            </div>
            <div className={styles.appointmentTable}>
                <table>
                    <tr className={styles.tableHead}>
                        <td>Property</td>
                        <td>Unit</td>
                        <td>Locker No</td>
                        <td>User Name</td>
                        <td>Booked Dates</td>
                        <td>Slots</td>
                        <td>Email</td>
                        <td>Contact No</td>
                    </tr>
                    <tr>
                        <td>Rise Construction Group</td>
                        <td>D 002</td>
                        <td>01</td>
                        <td>designer_corp</td>
                        <td>09/15/2022</td>
                        <td>10:00 AM To 12:00 PM</td>
                        <td>georgia.young@example.com</td>
                        <td>(704) 555-0127</td>
                    </tr>
                </table>
            </div>
            <div className={styles.logsDetails}>
                <div className={`${styles.historyWrapper} ${styles.wrapper}`}>
                    <h2 className={styles.logsTitle}>History</h2>
                    <div className={styles.logsDateTime}>
                        <div className={`${styles.logsWrap} ${styles.logsDate}`}>
                            <label>Select Date</label>
                            <div className={styles.timeWrap}>
                                <input type="date" name="historyLogs" />
                            </div>
                        </div>
                        <div className={`${styles.logsWrap} ${styles.logsTime}`}>
                            <label>Select Start Time {'>'} End Time</label>
                            <div className={styles.timeWrap}>
                                <input type="time" id="picker" name="picker"></input>
                                <span>{'>'}</span>
                                <input type="time" id="picker" name="picker"></input>
                            </div>
                        </div>
                    </div>
                    <div className={styles.logTable}>
                        <div className={styles.tableWrapper}>
                            <table>
                                <tr className={styles.tableHead}>
                                    <td>Photo</td>
                                    <td>Timestamp</td>
                                    <td>Link of appintment Page</td>
                                </tr>
                                <tr>
                                    <td className={styles.userAvatar}>
                                        <img src={dummyAvatar} alt="user" />
                                    </td>
                                    <td>09/13/2022, 9:15:45 AM</td>
                                    <td className={styles.unitLink}>D 001 Unit</td>
                                </tr>
                                <tr>
                                    <td className={styles.userAvatar}>
                                        <img src={dummyAvatar} alt="user" />
                                    </td>
                                    <td>09/13/2022, 9:15:45 AM</td>
                                    <td className={styles.unitLink}>D 001 Unit</td>
                                </tr>
                                <tr>
                                    <td className={styles.userAvatar}>
                                        <img src={dummyAvatar} alt="user" />
                                    </td>
                                    <td>09/13/2022, 9:15:45 AM</td>
                                    <td className={styles.unitLink}>D 001 Unit</td>
                                </tr>
                                <tr>
                                    <td className={styles.userAvatar}>
                                        <img src={dummyAvatar} alt="user" />
                                    </td>
                                    <td>09/13/2022, 9:15:45 AM</td>
                                    <td className={styles.unitLink}>D 001 Unit</td>
                                </tr>
                                <tr>
                                    <td className={styles.userAvatar}>
                                        <img src={dummyAvatar} alt="user" />
                                    </td>
                                    <td>09/13/2022, 9:15:45 AM</td>
                                    <td className={styles.unitLink}>D 001 Unit</td>
                                </tr>
                                <tr>
                                    <td className={styles.userAvatar}>
                                        <img src={dummyAvatar} alt="user" />
                                    </td>
                                    <td>09/13/2022, 9:15:45 AM</td>
                                    <td className={styles.unitLink}>D 001 Unit</td>
                                </tr>
                            </table>
                        </div>
                        <div className={styles.pagination}>
                            <span className={`${styles.back} ${styles.action}`}>
                                <img src={iconPagination} alt="Previous" />
                            </span>
                            <span className={`${styles.pageNum} ${styles.active}`}>1</span>
                            <span className={styles.pageNum}>2</span>
                            <span className={styles.pageNum}>3</span>
                            <span className={styles.pages}>...</span>
                            <span className={`${styles.next} ${styles.action}`}>
                                <img src={iconPagination} alt="Next" />
                            </span>
                        </div>
                    </div>
                </div>
                <div className={`${styles.assetsWrapper} ${styles.wrapper}`}>
                    <h2 className={styles.logsTitle}>Assest Status Log</h2>
                    <div className={styles.logsDateTime}>
                        <div className={`${styles.logsWrap} ${styles.logsDate}`}>
                            <label>Select Date</label>
                            <div className={styles.timeWrap}>
                                <input type="date" name="historyLogs" />
                            </div>
                        </div>
                        <div className={`${styles.logsWrap} ${styles.logsTime}`}>
                            <label>Select Start Time {'>'} End Time</label>
                            <div className={styles.timeWrap}>
                                <input type="time" id="picker" name="picker"></input>
                                <span>{'>'}</span>
                                <input type="time" id="picker" name="picker"></input>
                            </div>
                        </div>
                    </div>
                    <div className={styles.logTable}>
                        <div className={styles.tableWrapper}>
                            <table>
                                <tr className={styles.tableHead}>
                                    <td>Start Time</td>
                                    <td>End time</td>
                                    <td>Status</td>
                                </tr>
                                <tr>
                                    <td>09/13/2022, 9:15:45 AM</td>
                                    <td>09/13/2022, 10:05:23 PM</td>
                                    <td className={`${styles.status} ${styles.present}`}>
                                        <span>Present</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>09/13/2022, 9:15:45 AM</td>
                                    <td>09/13/2022, 10:05:23 PM</td>
                                    <td className={`${styles.status} ${styles.present}`}>
                                        <span>Present</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>09/13/2022, 9:15:45 AM</td>
                                    <td>09/13/2022, 10:05:23 PM</td>
                                    <td className={`${styles.status} ${styles.present}`}>
                                        <span>Present</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>09/13/2022, 9:15:45 AM</td>
                                    <td>09/13/2022, 10:05:23 PM</td>
                                    <td className={`${styles.status} ${styles.present}`}>
                                        <span>Present</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>09/13/2022, 9:15:45 AM</td>
                                    <td>09/13/2022, 10:05:23 PM</td>
                                    <td className={`${styles.status} ${styles.present}`}>
                                        <span>Present</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>09/13/2022, 9:15:45 AM</td>
                                    <td>09/13/2022, 10:05:23 PM</td>
                                    <td className={`${styles.status} ${styles.absent}`}>
                                        <span>Absent</span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div className={styles.pagination}>
                            <span className={`${styles.back} ${styles.action}`}>
                                <img src={iconPagination} alt="Previous" />
                            </span>
                            <span className={`${styles.pageNum} ${styles.active}`}>1</span>
                            <span className={styles.pageNum}>2</span>
                            <span className={styles.pageNum}>3</span>
                            <span className={styles.pages}>...</span>
                            <span className={`${styles.next} ${styles.action}`}>
                                <img src={iconPagination} alt="Next" />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.chargeDetails}>
                <div className={styles.damageDetails}>
                    <p className={styles.chargeText}>Visitor will be charged for</p>
                    <div className={styles.damages}>
                        <p className={`${styles.damage} ${styles.close}`}>
                            <span className={styles.damageText}>Not returned</span>
                            <span className={`${styles.action} ${styles.close}`}>+</span>
                        </p>
                        <p className={`${styles.damage}`}>
                            <span className={styles.damageText}>Key Damage</span>
                            <span className={`${styles.action} ${styles.close}`}>+</span>
                        </p>
                        <p className={`${styles.damage}`}>
                            <span className={styles.damageText}>Property Damage</span>
                            <span className={`${styles.action} ${styles.close}`}>+</span>
                        </p>
                    </div>
                </div>
                <div className={styles.damageField}>
                    <input type="text" name="charges" placeholder="Enter a amount to be charged" />
                    <button>Charge</button>
                </div>
            </div>
        </div>
    );
};

export default AppointmentDetails;
